import React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import MoreIcon from '@material-ui/icons/MoreVert';
import configBase from '../../../../configBase';



class Topbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userType: ''
    };

  }

  render() {
    const {onSidebarOpen, onSidebarClose, openSidebar} = this.props;

    let functionOnOffSidebar = onSidebarOpen;

    if (openSidebar === true)
      functionOnOffSidebar = onSidebarClose;

    return (
      <div id="appBar">
        <AppBar position="static" style={{backgroundColor:  configBase.corPrincipal}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={functionOnOffSidebar}
            >
              <MenuIcon />
            </IconButton>

            <div style={{flexGrow: 1, alignSelf: 'flex-end'}} />

            <IconButton aria-label="display more actions" edge="end" color="inherit">
              <MoreIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func,
  onSidebarClose: PropTypes.func,
  openSidebar: PropTypes.bool.isRequired,
};

export default Topbar;